import YtVideo from "../../../../src/components/ytvideo";
import NewsletterSection from "../../../../src/components/whitepaper/NewsletterSection";
import * as React from 'react';
export default {
  YtVideo,
  NewsletterSection,
  React
};